// ts-prune-ignore-file
import { FeatureFlagsConfig } from 'core/feature-flags/entities';
import { applePayExperiment, applePayExperimentConfig } from './applePayExperiment';
import {
  installCampaign2SenderExperiment,
  installCampaign2SenderExperimentConfig,
} from './installCampaign2SenderExperiment';
import { mediaBrandsExperiment, mediaBrandsExperimentConfig } from './mediaBrandsExperiment';
import {
  paymentActiveProvidersFeature,
  paymentActiveProvidersFeatureConfig,
} from './paymentActiveProvidersFeature';
import {
  appnebulaPaymentRedirectFeature,
  paymentRedirectFeatureConfig,
} from './paymentRedirectFeature';
import { phoneNumberOptInFeature, phoneNumberOptInFeatureConfig } from './phoneNumberFeature';
import {
  redirectToAsknebulaFeatureConfig,
  redirectToAsknebulaFeatureName,
} from './redirectToAsknebulaFeature';
import {
  requireEmailConsentFeature,
  requireEmailConsentFeatureConfig,
} from './requireEmailConsentFeature';
import { skipTrialChoiceFeature, skipTrialChoiceFeatureConfig } from './skipTrialChoiceFeature';
import {
  trialEndPaymentWhatsappExperiment,
  trialEndPaymentWhatsappExperimentConfig,
} from './trialEndPaymentWhatsappExperiment';
import { web2AppLinkFeature, web2AppLinkFeatureConfig } from './web2appLinkFeature';

// features
export * from './requireEmailConsentFeature';
export * from './phoneNumberFeature';
export * from './redirectToAsknebulaFeature';
export * from './paymentActiveProvidersFeature';
export * from './web2appLinkFeature';
export * from './paymentRedirectFeature';
export * from './installCampaign2SenderExperiment';
export * from './trialEndPaymentWhatsappExperiment';
export * from './mediaBrandsExperiment';
export * from './applePayExperiment';
export * from './skipTrialChoiceFeature';

export const featureFlagsConfig: FeatureFlagsConfig = {
  features: {
    [requireEmailConsentFeature]: requireEmailConsentFeatureConfig,
    [phoneNumberOptInFeature]: phoneNumberOptInFeatureConfig,
    [redirectToAsknebulaFeatureName]: redirectToAsknebulaFeatureConfig,
    [paymentActiveProvidersFeature]: paymentActiveProvidersFeatureConfig,
    [appnebulaPaymentRedirectFeature]: paymentRedirectFeatureConfig,
    [web2AppLinkFeature]: web2AppLinkFeatureConfig,
    [installCampaign2SenderExperiment]: installCampaign2SenderExperimentConfig,
    [trialEndPaymentWhatsappExperiment]: trialEndPaymentWhatsappExperimentConfig,
    [mediaBrandsExperiment]: mediaBrandsExperimentConfig,
    [applePayExperiment]: applePayExperimentConfig,
    [skipTrialChoiceFeature]: skipTrialChoiceFeatureConfig,
  },
};
